import { defineMessages } from 'react-intl';

export const priceUnitPriceMessages = defineMessages({
  unitPrice: {
    id: 'price.aria.unitPrice.label',
    defaultMessage: 'Grundpreis',
  },
  perUnit: {
    id: 'price.aria.perUnit.label',
    defaultMessage: 'pro',
  },
});
